exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_object-gops.js
// module id = Y1N3
// module chunks = 20